<template>
	<div>
			
			<div class="commonBox">
				<div>
					<div id="contactFrm">
			
						<div class="about">
							고객님께서 원하시는 꿈을 개발해드립니다.<br>
							언제든 편안하게 문의주세요 🥰
						</div>

						<div class="list">
							<p>
								<b>· TEL</b>
								<a href="tel: 1800-7841">1800-7841</a>
							</p>
							<p>
								<b>· E-MAIL</b>
								<a href="mailto: contact@134340.kr">contact@134340.kr</a>
							</p>
						</div>

						<div class="frm">
							<ul>
								<li>
									<input type="text" placeholder="성함 혹은 상호명" v-model="frmName" ref="frmName">
									<p class="line"></p>
								</li>
								<li>
									<input type="text" placeholder="연락받으실 번호" v-model="frmTel" ref="frmTel" pattern="\d*">
									<p class="line"></p>
								</li>
								<li>
									<textarea placeholder="문의하실 내용" v-model="frmMemo" ref="frmMemo"></textarea>
									<p class="line"></p>
								</li>
							</ul>
							
							<p class="notice">※ 개발문의접수 시 자동으로 <router-link to="/policy/personal"><b>개인정보처리방침</b></router-link>에 동의하게 됩니다.</p>

							<button type="button" id="contactSendBtn" @click="sendFrm()">개발문의하기</button>
						</div>

					</div>
				</div>
			</div>
		
	</div>
</template>

<style>
	#contactFrm > .about { width: 100%; float: left; font-size: 24px; line-height: 38px; }
	
	#contactFrm > .list { width: 100%; float: left; margin-top: 25px; }
	#contactFrm > .list > p { width: 100%; float: left; margin-top: 3px; font-size: 18px; }
	#contactFrm > .list > p > b { display: inline-block; width: 100px; }
	
	#contactFrm > .frm { width: 100%; float: left; margin-top: 60px; }
	#contactFrm > .frm > ul { width: 100%; float: left; }
	#contactFrm > .frm > ul > li { width: 100%; float: left; margin-bottom: 20px; }
	#contactFrm > .frm > ul > li > * { width: 100%; float: left; }
	#contactFrm > .frm > ul > li > input { height: 60px; border-bottom: 2px solid #DDD; font-size: 16px; font-weight: 100; padding: 0 20px; background-color: #FBFBFB; }
	#contactFrm > .frm > ul > li > textarea { height: 200px; border-bottom: 2px solid #DDD; font-size: 16px; font-weight: 100; padding: 20px; background-color: #FBFBFB; }
	#contactFrm > .frm > ul > li > .line { position: absolute; width: 0; height: 2px; z-index: 2; left: 0; bottom: 0; background-color: #0000C8; transition: all 0.5s; opacity: 0; }
	#contactFrm > .frm > ul > li > *:focus + .line { width: 100%; opacity: 1; }
	
	#contactFrm > .frm > .notice { width: 100%; float: left; margin-bottom: 20px; font-size: 11px; color: #999; }
	#contactFrm > .frm > .notice > a { text-decoration: underline; }
	
	#contactSendBtn { width: 100%; height: 80px; font-size: 18px; font-weight: 500; color: #FFF; background-color: #0000C8; transition: all 0.5s; border: 3px solid #0000C8; }
	
	@media (hover : hover){
		#contactFrm > .list > p > a:hover { text-decoration: underline; }
		#contactSendBtn:hover { color: #0000C8; background-color: #FFF; border-color: #0000C8; }
	}
	
	@media (max-width: 700px){
		#contactFrm > .about { font-size: 18px; line-height: 24px; }
		
		#contactFrm > .list { margin-top: 20px; }
		#contactFrm > .list > p { margin-top: 2px; font-size: 16px; }
		#contactFrm > .list > p > b { width: 80px; }

		#contactFrm > .frm { margin-top: 50px; }
		
		#contactSendBtn { height: 65px; font-size: 16px; }
	}
</style>

<script>
	var $;
	
	export default {
		name : "contact",
		data : function(){
			return {
				topVisualTitle : "개발문의",
				topVisualSub : "일삼사삼사공에서 꿈을 개발해드립니다.",
				frmName : "",
				frmTel : "",
				frmMemo : ""
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.$parent.pageOpen();
				$.$parent.topVisualTitle = $.topVisualTitle;
				$.$parent.topVisualSub = $.topVisualSub;
			},
			sendFrm : function(){
				if(!$.frmName){
					$.$refs.frmName.focus();
					return false;
				}
				
				if(!$.frmTel){
					$.$refs.frmTel.focus();
					return false;
				}
				
				if(!$.frmMemo){
					$.$refs.frmMemo.focus();
					return false;
				}
				
				$.$parent.coverShow = true;
				
				var frmData = new FormData();
				frmData.append("frmName", $.frmName);
				frmData.append("frmTel", $.frmTel);
				frmData.append("frmMemo", $.frmMemo);
				
				$.$axios.post("//api.134340.kr/contact/send", frmData, { headers: $.$axiosHeader }).then(function(res){
					setTimeout(function(){
						$.frmName = "";
						$.frmTel = "";
						$.frmMemo = "";
						
						$.$parent.msgBoxOpen("개발문의 접수가 완료되었습니다🥳<br>빠른 시일내로 연락드리겠습니다.");
						$.$parent.coverShow = false;
					}, 3000);
				});
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/contact.vue